import { db } from "../../../config/firebaseconfig"
import uuid from 'uuid/v1'
import crypto from 'crypto'
import { findUniqueUsername } from "./"

/**
 * Creates an individual teacher if a duplicate does not already exist in the database.
 * @param {string} name The identifying name of the teacher (shortname, username, or email)
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 */
export default function createTeacher (name, school, schoolYear) {
  name = name.toLowerCase()
  const id = uuid()
  const { district } = school
  let teacherData

  function isEmailQ (text) {
    return text.indexOf('@') > -1 && text.indexOf('.') > -1
  }
  // check for duplicates (dup email or dup username with same school district)

  // fetch all educators with same email
  const fetchByEmail = db.collection('educators').where('email', '==', name).get()

  // fetch all educators with same username
  const fetchByUsername = db.collection('educators').where('username', '==', name).get()
  let duplicateFound = false

  return Promise.all([fetchByEmail, fetchByUsername])
    .then(results => {
      let usernameDup = false
      const [ emailResults, usernameResults ] = results
      emailResults.forEach(doc => {
        if (doc.exists) duplicateFound = true
      })
      usernameResults.forEach(doc => {
        if (doc.exists) {
          if (doc.data().schoolDistrict === district) {
            if (doc.get('school') === school.id) {
              duplicateFound = true
            } else {
              usernameDup = true
            }
          }
        }
      })
      let promises = []
      if (usernameDup && !duplicateFound) {
        const getUniqueUsername = findUniqueUsername(district, name, 'educators') 
        promises.push(getUniqueUsername)
      }
      return Promise.all(promises)
    })
    .then(results => {
      if (duplicateFound) return 'duplicate'
      results.forEach(result => {
        if (result) {
          name = result
        }
      })
      const isEmail = isEmailQ(name)
      const secret = 'ncvjrwenvrewjn9123!'

      // set up new user data
      const inviteId = uuid()
      const time = Date.now()
      const batch = db.batch()

      // set up refs
      const teacherRef = db.collection('educators').doc(id)
      const schoolRef = db.collection('schools').doc(school.id)
      const inviteRef = db.collection('userInvites').doc(inviteId)
      const passwordRef = db.collection('educatorsAuth').doc(id)

      teacherData = {
        id,
        email: isEmail ? name : '',
        username: name,
        firstName: '',
        lastName: name,
        fullName: name,
        state: school.state,
        school: school.id,
        schoolDistrict: school.district,
        lastModified: time,
        created: time,
        role: 'Teacher',
        isTeacher: true,
        sfid: '',
        validated: !isEmail,
        classes: {},
      }
      
      // add invite if email instead of username
      if (isEmail) {
        batch.set(inviteRef, {
          id: inviteId,
          userId: id,
          createdDate: time,
          expirationDate: (time + 259200000), 
          firstName: '',
          lastName: name,
          email: name,
        })
      }
      
      // update password if username instead of email
      // the username all lowercase is the password
      console.log('name', name)
      if (!isEmail) {
        teacherData.password = name
        const hash = crypto.createHmac('sha256', secret).update(name).digest('hex')
        batch.set(passwordRef, { id, hash, })
      }

      // update educator record
      batch.set(teacherRef, teacherData)

      // update parent record
      const teacherKey = `teachers.${id}`
      batch.update(schoolRef, {[teacherKey]: true})

      return batch.commit()
    })
    .then(result => {
      if (result === 'duplicate') return null
      return teacherData
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createTeacher.js